import { LanguageShort } from '../models/language.models';

export const Variables = {
  STORAGE: {
    AUTH_USER: 'admin_authenticated_user',
    AUTH_TOKEN: 'admin_auth_token',
  },
  DEFAULT_PAGE_SIZE: 32,
  DEFAULT_LNG: 'en' as LanguageShort,
};
